import { render, staticRenderFns } from "./main.pug?vue&type=template&id=e361d358&scoped=true&lang=pug&"
import script from "./main.ts?vue&type=script&lang=ts&"
export * from "./main.ts?vue&type=script&lang=ts&"
import style0 from "./main.scss?vue&type=style&index=0&id=e361d358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e361d358",
  null
  
)

export default component.exports